export class KitLot {
    reagent: string;
    lot: string;
}